import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableMenuView extends JetView {
    /**
     * Configures the view and sets up event listeners.
     * @returns {Object} Configuration object for the view
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Retrieves partner ID from parameters
        var filter = {}; // Filter object for data processing

        /**
         * Sets data for the filter and sends it to the server.
         */
        function setData() {
            var text = JSON.stringify($$('ss1').serialize(), null, '  '); // Serializes spreadsheet data
            var data = JSON.parse(text); // Parses serialized data
            var json = JSON.parse(text).data; // Extracts data array
            var object = {}; // Temporary object for column mapping
            var array = []; // Array to hold column objects
            let numcolumns = 0; // Counter for number of columns

            // Counts the number of columns based on the first element of each row
            json.forEach(function (obj) {
                if (obj[0] == 1) {
                    numcolumns++;
                }
            });

            var numrows = json.length / numcolumns - 1; // Calculates number of rows
            for (var i = 0; i < numrows; i++) {
                object = {}; // Resets object for each row
                json.forEach(function (obj) {
                    if (obj[0] == 1) {
                        object[obj[2]] = null; // Initializes object keys
                    }
                });
                array.push(object); // Adds object to array
            }

            // Populates the array with data from json
            array.forEach(function (item, i) {
                json.forEach(function (obj) {
                    if (obj[0] - 2 == i) {
                        item[Object.keys(object)[obj[1] - 1]] = obj[2].toString(); // Maps values to keys
                    }
                });
            });

            filter.Data = {
                Columns: array, // Sets columns in filter
                Excel: data, // Sets Excel data in filter
            };

            // Sends data to the server
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Sets content type
                })
                .post(
                    devConfig.geturlApi() + 'Setting/SetControlFiscal', // API endpoint
                    filter, // Data to send
                    {
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parses server response
                            if (!resp.HasError) {
                                webix.message(_('Reporte guardado')); // Success message
                            } else {
                                webix.alert({
                                    type: 'alert-error',
                                    title: 'Error',
                                    text: _('Error! '), // Error alert
                                });
                            }
                        },
                    },
                );
        }

        // Event listener for filter updates
        this.on(this.app, 'control:filter', (filterData) => {
            var object = Object.entries(filterData); // Converts filter data to entries
            var string1 = ''; // Query string for API call
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Builds query string
                } else {
                    if (typeof object[i][1] === 'object') {
                        if (object[i][0] === 'Date') {
                            var d = new Date(object[i][1]); // Converts date object
                            var dateFrom =
                                'DateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                '01'; // Formats date
                            string1 = string1 + '&' + dateFrom; // Adds date to query string
                        }
                    }
                }
            }
            filter = Object.fromEntries(new URLSearchParams(string1)); // Converts query string back to object

            // Sends GET request to fetch filtered data
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Sets content type
                })
                .get(
                    devConfig.geturlApi() + 'Financial/GetControlFiscal?' + string1, // API endpoint with query string
                    {
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parses server response
                            if (!resp.HasError && resp.Data != undefined && resp.Data.Excel != undefined) {
                                $$('ss1').parse(resp.Data.Excel); // Parses Excel data into spreadsheet
                            } else {
                                $$('ss1').reset(); // Resets spreadsheet on error
                            }
                        },
                    },
                );
        });

        // Event listener for saving the table
        this.on(this.app, 'save:table', (filterData) => {
            setData(); // Calls setData to save the current state
        });

        // Returns the configuration for the view
        return {
            rows: [
                {
                    id: 'ss1', // ID for the spreadsheet
                    view: 'spreadsheet', // Specifies the view type
                    toolbar: 'full', // Enables full toolbar
                },
            ],
        };
    }
}

// FILE DOCUMENTED
